<ada-card #MainElement>
	<ada-text
		data-container-selector="ada-card-header"
		[content]="cardTitle"
	></ada-text>
	<ada-container
		data-container-selector="ada-card-body"
		verticalSpacing="medium"
	>
		<ada-chart
			height="12rem"
			[chart]="totalCveChart"
			[data]="chartData$ | async"
		/>
		<!-- Undetermined CVEs display -->
		<div
			style="display: flex; flex-direction: row; flex-grow: 1"
			[ngStyle]="{
				gap: ui.Spacing.SPACING_MEDIUM,
				'padding-top': ui.Spacing.SPACING_MEDIUM,
			}"
			class="ada-border-top"
		>
			<span
				data-testid="cve-counts-display-cannot-determine"
				class="ada-color-primary"
				ada-type="large"
			>
				{{ counts?.cannotDetermine | placeholderIfEmpty }}
			</span>
			<div>
				<span
					class="ada-color-primary"
					ada-type="big"
				>
					Undetermined CVEs
				</span>
			</div>
		</div>
	</ada-container>
</ada-card>
